module.exports = __webpack_public_path__ + "static/media/character.2f9a7506.png";